import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import moment from "moment";
// Styles
import "../../../assets/saas/molecules/_timepicker.scss";
import React from "react";
const TimePickerModal = ({ startTime, endTime, setShowTimeModal, setStartTime, setEndTime, showTimeModal, startDate, endDate, t, getData }) => {
    //create an array of hours from 12:00 am to 11:30 pm with 30 minutes interval
    let hours = [];
    let periods = [];
    let minutes = ["00", "30"];
    const [trigger, setTrigger] = React.useState(0);
    const [selectStartTime, setSelectStartTime] = useState(startTime);
    const [selectEndTime, setSelectEndTime] = useState(endTime);
    const [pickToday, setPickToday] = useState(false);
    const [dropToday, setDropToday] = useState(false);
    const [actualHour, setActualHour] = useState(moment().format("HH:mm"));
    for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 2; j++) {
            let hour12 = moment({ hour: i % 12 || 12, minute: 0 }).format("hh"); // Use Moment.js to format hours with 2 digits in 12-hour format
            let minute = minutes[j];
            let period = i < 12 ? "am" : "pm";
            hours.push(hour12 + ":" + minute);
            periods.push(period);
        }
    }
    useEffect(() => {
        if (trigger != 0) {
            getData();
        }
    }, [trigger]);
    //scroll the element of class hours-options_container to the element with the class active_hour
    useEffect(() => {
        var _a, _b;
        if (startDate[1] === moment().format("YYYY-MM-DD")) {
            setPickToday(true);
        }
        else {
            setPickToday(false);
        }
        if (endDate[1] === moment().format("YYYY-MM-DD")) {
            setDropToday(true);
        }
        else {
            setDropToday(false);
        }
        if (showTimeModal) {
            setSelectEndTime(endTime);
            setSelectStartTime(startTime);
            const activeHour = document.getElementsByClassName("active_hour")[0];
            const activedropHour = document.getElementsByClassName("active_hour")[1];
            if (activeHour)
                activeHour.scrollIntoView({ behavior: "auto", block: "center" });
            if (activedropHour)
                activedropHour.scrollIntoView({ behavior: "auto", block: "center" });
            (_a = document.querySelector(".timepicker-wrapper")) === null || _a === void 0 ? void 0 : _a.addEventListener("touchmove", function (event) {
                event.preventDefault();
            }, { passive: false });
            (_b = document.querySelector(".container__footer")) === null || _b === void 0 ? void 0 : _b.addEventListener("touchmove", function (event) {
                event.preventDefault();
            }, { passive: false });
            document.body.style.position = "relative";
        }
        else {
            //remove the position relative from the body
            document.body.style.position = "";
            setSelectEndTime(endTime);
            setSelectStartTime(startTime);
        }
    }, [showTimeModal]);
    const setActiveHour = (hour, index, period, type, e) => {
        const hoursOptionsPick = document.querySelector(".hours-pick");
        const hoursOptionsDrop = document.querySelector(".hours-drop");
        const timeOptions = hoursOptionsPick === null || hoursOptionsPick === void 0 ? void 0 : hoursOptionsPick.querySelectorAll(".hour-container");
        const timeOptionsDrop = hoursOptionsDrop === null || hoursOptionsDrop === void 0 ? void 0 : hoursOptionsDrop.querySelectorAll(".hour-container");
        const time12 = hour + " " + period.toLowerCase();
        const time24 = convertTo24HourFormat(hour, period);
        if (type === "pick") {
            timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.forEach((timeOption) => {
                timeOption.classList.remove("active_hour");
            });
            setTimeout(() => {
                var _a;
                (_a = document
                    .getElementById("pick_option_" + index)) === null || _a === void 0 ? void 0 : _a.classList.add("active_hour");
            }, 50);
            setSelectStartTime([time12, time24]);
        }
        else {
            timeOptionsDrop === null || timeOptionsDrop === void 0 ? void 0 : timeOptionsDrop.forEach((timeOption) => {
                timeOption.classList.remove("active_hour");
            });
            setTimeout(() => {
                var _a;
                (_a = document
                    .getElementById("drop_option_" + index)) === null || _a === void 0 ? void 0 : _a.classList.add("active_hour");
            }, 50);
            setSelectEndTime([time12, time24]);
        }
    };
    const convertTo24HourFormat = (hour, period) => {
        const time12 = hour + " " + period;
        const time24 = moment(time12, "hh:mm A").format("HH:mm");
        return time24;
    };
    useEffect(() => {
        const hoursOptionsPick = document.querySelector(".hours-pick");
        const hoursOptionsDrop = document.querySelector(".hours-drop");
        const timeOptions = hoursOptionsPick === null || hoursOptionsPick === void 0 ? void 0 : hoursOptionsPick.querySelectorAll(".hour-container");
        const timeOptionsDrop = hoursOptionsDrop === null || hoursOptionsDrop === void 0 ? void 0 : hoursOptionsDrop.querySelectorAll(".hour-container");
        timeOptions === null || timeOptions === void 0 ? void 0 : timeOptions.forEach((timeOption, index) => {
            var _a, _b;
            if (((_a = timeOption.querySelector("span#hour_" + index)) === null || _a === void 0 ? void 0 : _a.textContent) +
                " " +
                ((_b = timeOption.querySelector("span#period_" + index)) === null || _b === void 0 ? void 0 : _b.textContent) ===
                startTime[0].toLowerCase()) {
                timeOption.classList.add("active_hour");
                timeOption.scrollIntoView({ behavior: "auto", block: "center" });
            }
            else {
                timeOption.classList.remove("active_hour");
            }
        });
        timeOptionsDrop === null || timeOptionsDrop === void 0 ? void 0 : timeOptionsDrop.forEach((timeOption, index) => {
            var _a, _b;
            if (((_a = timeOption.querySelector("span#hour_" + index)) === null || _a === void 0 ? void 0 : _a.textContent) +
                " " +
                ((_b = timeOption.querySelector("span#period_" + index)) === null || _b === void 0 ? void 0 : _b.textContent) ===
                endTime[0].toLowerCase()) {
                timeOption.classList.add("active_hour");
                timeOption.scrollIntoView({ behavior: "auto", block: "center" });
            }
            else {
                timeOption.classList.remove("active_hour");
            }
        });
    }, [showTimeModal]);
    // run setInitialActiveHours but only once when the component is mounted
    const applySelection = () => {
        setStartTime(selectStartTime);
        setEndTime(selectEndTime);
        setTimeout(() => {
            setTrigger(Math.floor(Math.random() * 5000) + 1);
        }, 700);
        setShowTimeModal(false);
    };
    return (_jsxs("div", { id: "time_picker_modal", className: "time-picker", style: { display: showTimeModal ? "flex" : "none" }, children: [_jsx("div", { className: "time-picker__dummy-header", children: "_______" }), _jsxs("div", { className: "time-picker__wrapper", children: [_jsx("div", { className: "searchbar__col", children: _jsxs("div", { className: "searchbar__location", children: [_jsx("div", { className: "searchbar__location-title", children: t("time-selector-title") }), _jsxs("div", { className: "searchbar__location-inner", children: [_jsxs("svg", { className: "time_icon", xmlns: "http://www.w3.org/2000/svg", id: "Icon-Time", width: "21", height: "21", viewBox: "0 0 21 21", children: [_jsx("rect", { id: "Safe", width: "21", height: "21", fill: "none" }), _jsx("g", { id: "Icon", children: _jsx("path", { id: "Path", d: "M13372,22338.752a8.75,8.75,0,1,1,8.749,8.748A8.76,8.76,0,0,1,13372,22338.752Zm1.3,0a7.448,7.448,0,1,0,7.447-7.449A7.459,7.459,0,0,0,13373.3,22338.752Zm11.536,3.105-4.414-2.545a.654.654,0,0,1-.325-.561v-5.553a.651.651,0,1,1,1.3,0v5.182l4.083,2.35a.65.65,0,0,1-.324,1.215A.615.615,0,0,1,13384.839,22341.857Z", transform: "translate(-13370.25 -22328.25)", stroke: "rgba(0,0,0,0)", strokeWidth: "1" }) })] }), _jsxs("div", { className: "time-picker__timeplaceholder", id: "time_input_info", children: [_jsx("span", { children: selectStartTime[0].toLowerCase() }), _jsx("span", { children: "-" }), _jsx("span", { children: selectEndTime[0].toLowerCase() })] })] })] }) }), _jsxs("div", { className: "time-picker__header-title", children: [_jsx("div", { className: "time-picker__header-text", children: t("time-selector-pickup") }), _jsx("div", { className: "time-picker__header-text", children: t("time-selector-dropoff") })] })] }), _jsxs("div", { className: "time-picker__hours-container", children: [_jsx("div", { className: "hours-pick", children: hours.map((hour, index) => {
                            return (_jsx("div", { className: "hours_option", onClick: pickToday && moment(hour + " " + periods[index], "hh:mm a").format("HH:mm") <= actualHour ? (e) => { } : (e) => {
                                    setActiveHour(hour, index, periods[index], "pick", e);
                                }, children: _jsxs("div", { className: pickToday && moment(hour + " " + periods[index], "hh:mm a").format("HH:mm") <= actualHour ? "hour-container disable" : "hour-container", id: "pick_option_" + index, children: [_jsx("span", { id: "hour_" + index, children: hour }), _jsx("span", { id: "period_" + index, children: periods[index] })] }) }, index));
                        }) }), _jsx("div", { className: "hours-drop", children: hours.map((hour, index) => {
                            return (_jsx("div", { className: "hours_option", onClick: dropToday && moment(hour + " " + periods[index], "hh:mm a").format("HH:mm") <= actualHour ? (e) => { } : (e) => {
                                    setActiveHour(hour, index, periods[index], "drop", e);
                                }, children: _jsxs("div", { className: dropToday && moment(hour + " " + periods[index], "hh:mm a").format("HH:mm") <= actualHour ? "hour-container disable" : "hour-container", id: "drop_option_" + index, children: [_jsx("span", { id: "hour_" + index, children: hour }), _jsx("span", { id: "period_" + index, children: periods[index] })] }) }, index));
                        }) })] }), _jsx("div", { className: "time-picker__footer", children: _jsx("button", { className: "button-primary button--rounded", onClick: applySelection, children: t("button-apply") }) })] }));
};
export default TimePickerModal;
